import * as App from "./app";

export default App;
